export const getHomePageStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "MDBApp.io",
  "applicationCategory": "DeFi / Cryptocurrency",
  "operatingSystem": ["Web-based", "Android", "iOS"],
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "156"
  },
  "description": "Create BEP20 tokens on Binance Smart Chain with full mobile wallet support (SafePal, Trust Wallet, MetaMask). Featuring automated burns, instant verification, and advanced liquidity management.",
  "downloadUrl": "https://mdbapp.io",
  "featureList": [
    "Multi-Wallet Support (SafePal, Trust Wallet, MetaMask)",
    "Mobile-First DeFi Platform",
    "BEP20 Token Creation",
    "Automated Token Burns",
    "Deflationary Tokenomics",
    "Audit-Ready Smart Contracts"
  ],
  "screenshot": "https://mdbapp.io/screenshot.png",
  "softwareVersion": "8.0",
  "author": {
    "@type": "Organization",
    "name": "MDBApp",
    "url": "https://mdbapp.io"
  },
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "DeFi Developer"
    },
    "reviewBody": "Best mobile-friendly token creator on BSC. Supports all major wallets and very easy to use."
  }
});

export const getTokenPageStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "WebApplication",
  "name": "BSC Token Creator",
  "applicationCategory": "DeFi / Cryptocurrency",
  "operatingSystem": ["Web-based", "Android", "iOS"],
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "USD"
  },
  "description": "Create your own BEP20 token on BSC with full mobile wallet support. Instant token deployment, automated verification, and one-click wallet integration.",
  "downloadUrl": "https://mdbapp.io/create",
  "featureList": [
    "Multi-Wallet Support",
    "One-Click Token Addition",
    "Mobile-Optimized Interface",
    "Automatic Contract Deployment",
    "Contract Verification",
    "Gas-Optimized Contracts"
  ],
  "screenshot": "https://mdbapp.io/token-creator-screenshot.png",
  "softwareVersion": "8.0",
  "author": {
    "@type": "Organization",
    "name": "MDBApp",
    "url": "https://mdbapp.io"
  },
  "potentialAction": {
    "@type": "CreateAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://mdbapp.io/create",
      "actionPlatform": [
        "https://schema.org/DesktopWebPlatform",
        "https://schema.org/MobileWebPlatform"
      ]
    },
    "result": {
      "@type": "CreativeWork",
      "name": "BEP20 Token"
    }
  }
});

export const getOrganizationStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "MDBApp",
  "url": "https://mdbapp.io",
  "logo": "https://mdbapp.io/logo.png",
  "sameAs": [
    "https://twitter.com/mobdaboss",
    "https://t.me/mdbapp",
    "https://github.com/mdbapp"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer support",
    "url": "https://t.me/mdbapp"
  }
});
